module.exports = __webpack_public_path__ + "img/mobile-elbow-16_70x52.7ec9207f.png";